/******/ (function() { // webpackBootstrap
/******/ 	"use strict";

// UNUSED EXPORTS: default

;// ./src/scripts/components/newsletterAfterSubmit.js
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * NewsletterFormAfterSubmit Class
 *
 * This class handles the post-submission state of newsletter forms.
 * It monitors for success elements to appear and applies custom styling
 * to both the success message and submit button.
 *
 * @class
 */
var NewsletterFormAfterSubmit = /*#__PURE__*/function () {
  /**
   * Creates an instance of NewsletterFormAfterSubmit.
   *
   * @param {string} formSelector - CSS selector to target the newsletter form container (default: '.newsletter-form-footer')
   * @param {Object} options - Configuration options
   * @param {number} options.maxAttempts - Maximum number of attempts to check for success element (default: 20)
   * @param {number} options.checkInterval - Interval in milliseconds between checks (default: 100)
   * @param {string} options.submitButtonSelector - CSS selector for the submit button (default: '.gfb__footer button[type="submit"]')
   * @param {string} options.successClass - CSS selector for the success message element (default: '.success')
   */
  function NewsletterFormAfterSubmit() {
    var formSelector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.newsletter-form-footer';
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, NewsletterFormAfterSubmit);
    // Find all forms matching the selector
    this.forms = _toConsumableArray(document.querySelectorAll(formSelector));

    // Set default options or use provided options
    this.options = {
      maxAttempts: options.maxAttempts || 20,
      checkInterval: options.checkInterval || 100,
      submitButtonSelector: options.submitButtonSelector || '.gfb__footer button[type="submit"]',
      successClass: options.successClass || '.success'
    };

    // Initialize if forms are found, otherwise log a warning
    if (this.forms.length > 0) {
      this.init();
    } else {
      console.warn("Form with selector \"".concat(formSelector, "\" not found."));
    }
  }

  /**
   * Initializes the monitoring for success elements.
   * Sets up an interval to check for success elements and applies styling when found.
   *
   * @returns {void}
   */
  return _createClass(NewsletterFormAfterSubmit, [{
    key: "init",
    value: function init() {
      var _this = this;
      var attempts = 0;

      // Set up interval to check for success elements
      var checkSuccessInterval = setInterval(function () {
        // Check if any form has a success element
        if (_this.forms.some(function (form) {
          return form.querySelector(_this.options.successClass);
        })) {
          // Success element found, apply styling
          _this.styleSuccessElements();
          clearInterval(checkSuccessInterval);
        } else {
          // Increment attempts and clear interval if max attempts reached
          attempts++;
          if (attempts >= _this.options.maxAttempts) {
            console.warn('Stopped checking for success element after maximum attempts');
            clearInterval(checkSuccessInterval);
          }
        }
      }, this.options.checkInterval);
    }

    /**
     * Applies custom styling to success elements and submit buttons.
     * Shows only the first success element and hides any others.
     * Adds custom classes and SVG icon to the submit button.
     *
     * @returns {void}
     */
  }, {
    key: "styleSuccessElements",
    value: function styleSuccessElements() {
      var _this2 = this;
      // Show only the first success element, hide any others
      this.forms.forEach(function (form) {
        var successElements = _toConsumableArray(form.querySelectorAll(_this2.options.successClass));
        successElements.forEach(function (element, index) {
          // Display only the first success element
          element.style.display = index === 0 ? 'flex' : 'none';
          if (index === 0) {
            element.classList.add('success-message-custom');
          }
        });
      });

      // Style the submit button with custom classes and SVG icon
      this.forms.forEach(function (form) {
        var submitButton = form.querySelector(_this2.options.submitButtonSelector);
        if (submitButton) {
          submitButton.classList.add('newsletter-form__button', 'field__button');
          // Replace button content with arrow SVG icon
          submitButton.innerHTML = "<svg width=\"26\" height=\"26\" viewBox=\"0 0 26 26\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n        <path d=\"M18.0192 12.993H7.96744\" stroke=\"white\" stroke-width=\"1.16071\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n        <path d=\"M13.3734 17.627L18.0286 13.0019L13.3734 8.37683\" stroke=\"white\" stroke-width=\"1.16071\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n      </svg>";
        }
      });
    }
  }]);
}(); // Export the class
/* harmony default export */ var newsletterAfterSubmit = (NewsletterFormAfterSubmit);
;// ./src/scripts/components/newsletterBeforeSubmit.js
function newsletterBeforeSubmit_typeof(o) { "@babel/helpers - typeof"; return newsletterBeforeSubmit_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, newsletterBeforeSubmit_typeof(o); }
function newsletterBeforeSubmit_toConsumableArray(r) { return newsletterBeforeSubmit_arrayWithoutHoles(r) || newsletterBeforeSubmit_iterableToArray(r) || newsletterBeforeSubmit_unsupportedIterableToArray(r) || newsletterBeforeSubmit_nonIterableSpread(); }
function newsletterBeforeSubmit_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function newsletterBeforeSubmit_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return newsletterBeforeSubmit_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? newsletterBeforeSubmit_arrayLikeToArray(r, a) : void 0; } }
function newsletterBeforeSubmit_iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function newsletterBeforeSubmit_arrayWithoutHoles(r) { if (Array.isArray(r)) return newsletterBeforeSubmit_arrayLikeToArray(r); }
function newsletterBeforeSubmit_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function newsletterBeforeSubmit_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function newsletterBeforeSubmit_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, newsletterBeforeSubmit_toPropertyKey(o.key), o); } }
function newsletterBeforeSubmit_createClass(e, r, t) { return r && newsletterBeforeSubmit_defineProperties(e.prototype, r), t && newsletterBeforeSubmit_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function newsletterBeforeSubmit_toPropertyKey(t) { var i = newsletterBeforeSubmit_toPrimitive(t, "string"); return "symbol" == newsletterBeforeSubmit_typeof(i) ? i : i + ""; }
function newsletterBeforeSubmit_toPrimitive(t, r) { if ("object" != newsletterBeforeSubmit_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != newsletterBeforeSubmit_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * NewsletterFormBeforeSubmit Class
 *
 * This class handles the initialization and configuration of newsletter forms
 * before they are submitted. It sets brand information in a hidden field and
 * styles the submit button with an SVG icon.
 *
 * @class
 */
var newsletterBeforeSubmit_NewsletterFormBeforeSubmit = /*#__PURE__*/function () {
  /**
   * Creates an instance of NewsletterFormBeforeSubmit.
   *
   * @param {string} formSelector - CSS selector to target the newsletter form container (default: '.newsletter-form-footer')
   * @param {Object} options - Configuration options
   * @param {string} options.hiddenFieldName - Name of the hidden field to store brand information (default: 'hidden-1')
   * @param {string} options.submitButtonSelector - CSS selector for the submit button (default: '.gfb__footer button[type="submit"]')
   */
  function NewsletterFormBeforeSubmit() {
    var formSelector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.globo-form';
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    newsletterBeforeSubmit_classCallCheck(this, NewsletterFormBeforeSubmit);
    this.initialized = false;
    this.formSelector = formSelector;
    this.options = {
      hiddenFieldName: options.hiddenFieldName || 'hidden-1',
      hiddenFieldName2: options.hiddenFieldName2 || 'hidden-2',
      submitButtonSelector: options.submitButtonSelector || '.gfb__footer button[type="submit"]'
    };
    this.init();
  }

  /**
   * Initializes the newsletter form by setting brand information and styling the submit button.
   *
   * This method:
   * 1. Gets the brand value from Shopify or uses a default
   * 2. Finds all matching newsletter forms in the document
   * 3. Sets the hidden field value with brand information
   * 4. Styles the submit button with an SVG icon
   *
   * @returns {void}
   */
  return newsletterBeforeSubmit_createClass(NewsletterFormBeforeSubmit, [{
    key: "init",
    value: function init() {
      var _this = this;
      // Prevent multiple initializations
      if (this.initialized || window.NewsletterFormBeforeSubmitInitialized) return;
      try {
        // Get brand value from Shopify or use default
        var brandSource = window.Shopify && window.Shopify.alternateBrand && window.Shopify.alternateBrand.brand;
        if (!brandSource && !window.Shopify) {
          console.warn('Shopify object not found, using default brand value.');
        }

        // Capitalize first letter of brand name
        var brandValue = this.capitalizeFirstLetter(brandSource || 'Gibson');

        // Find and initialize the form
        this.newsletterForms = newsletterBeforeSubmit_toConsumableArray(document.querySelectorAll("".concat(this.formSelector, " form[data-id]")));
        if (!this.newsletterForms || this.newsletterForms.length === 0) {
          console.warn('Newsletter form not found.');
          return;
        }

        // Set hidden field value with brand information
        this.newsletterForms.forEach(function (form) {
          var sourceLabel = form.querySelector('[data-label="Source Label"]');
          var localeLabel = form.querySelector('[data-label="Locale"]');
          var hiddenField = form.querySelector("input[name=\"".concat(_this.options.hiddenFieldName, "\"]"));
          var hiddenFieldTwo = form.querySelector("input[name=\"".concat(_this.options.hiddenFieldName2, "\"]")) || sourceLabel;
          var localeField = form.querySelector('input[name="hidden-3"]') || localeLabel;
          if (hiddenField) {
            hiddenField.value = "brand--".concat(brandValue);
          } else {
            console.warn('Hidden field not found in form');
          }
          if (hiddenFieldTwo) {
            var _sourceLabel = hiddenFieldTwo.value;
            var optInSource = "".concat(brandValue, " - ").concat(window.Shopify.locale, "-").concat(window.Shopify.country, " ").concat(_sourceLabel);
            hiddenFieldTwo.value = optInSource;
          } else {
            console.warn('Hidden field not found in form');
          }
          if (localeField) {
            localeField.value = "".concat(window.Shopify.locale, "-").concat(window.Shopify.country.toUpperCase());
          } else {
            console.warn('Locale field not found in form');
          }
          if (form.parentElement.closest('.globo-form').classList.contains('newsletter-form-footer')) {
            _this.styleSubmitButton(form);
          }
        });
        this.initialized = true;
        window.NewsletterFormBeforeSubmitInitialized = true;
      } catch (error) {
        console.error('Error initializing newsletter form:', error);
      }
    }

    /**
     * Helper function to capitalize the first letter of a string.
     *
     * @param {string} string - The input string to capitalize
     * @returns {string} The string with its first letter capitalized
     */
  }, {
    key: "capitalizeFirstLetter",
    value: function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }

    /**
     * Adds styling to the submit button and inserts an SVG icon.
     *
     * This method:
     * 1. Finds the submit button in each form
     * 2. Adds CSS classes for styling
     * 3. Replaces the button content with an SVG arrow icon
     *
     * @returns {void}
     */
  }, {
    key: "styleSubmitButton",
    value: function styleSubmitButton(form) {
      var submitButton = form.querySelector(this.options.submitButtonSelector);
      if (!submitButton) {
        console.warn('Submit button not found');
        return;
      }

      // Add CSS classes
      submitButton.classList.add('newsletter-form__button', 'field__button');

      // Set button content with arrow SVG
      submitButton.innerHTML = "<svg width=\"26\" height=\"26\" viewBox=\"0 0 26 26\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path d=\"M18.0192 12.993H7.96744\" stroke=\"white\" stroke-width=\"1.16071\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n      <path d=\"M13.3734 17.627L18.0286 13.0019L13.3734 8.37683\" stroke=\"white\" stroke-width=\"1.16071\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n    </svg>";
    }
  }]);
}(); // Export the class
/* harmony default export */ var newsletterBeforeSubmit = (newsletterBeforeSubmit_NewsletterFormBeforeSubmit);
;// ./src/scripts/sections/newsletter-brands.js
function newsletter_brands_typeof(o) { "@babel/helpers - typeof"; return newsletter_brands_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, newsletter_brands_typeof(o); }
function newsletter_brands_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function newsletter_brands_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, newsletter_brands_toPropertyKey(o.key), o); } }
function newsletter_brands_createClass(e, r, t) { return r && newsletter_brands_defineProperties(e.prototype, r), t && newsletter_brands_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function newsletter_brands_toPropertyKey(t) { var i = newsletter_brands_toPrimitive(t, "string"); return "symbol" == newsletter_brands_typeof(i) ? i : i + ""; }
function newsletter_brands_toPrimitive(t, r) { if ("object" != newsletter_brands_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != newsletter_brands_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


document.addEventListener('DOMContentLoaded', function () {
  if (typeof window.Globo !== 'undefined' && window.Globo !== null && typeof window.Globo.FormBuilder !== 'undefined' && window.Globo.FormBuilder !== null && typeof window.Globo.FormBuilder.initialize === 'function') {
    window.Globo.FormBuilder.initialize();
  } else {
    console.warn('Globo FormBuilder is not available on window. Initialization skipped.');
  }
});
document.addEventListener('newsletterAfterSubmit', function () {
  new newsletterAfterSubmit();
});
document.addEventListener('newsletterBeforeSubmit', function () {
  new newsletterBeforeSubmit();
});

// Export the class for backward compatibility.
var NewsletterBrands = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  function NewsletterBrands() {
    newsletter_brands_classCallCheck(this, NewsletterBrands);
    console.warn('NewsletterBrands is deprecated. Use NewsletterFormBeforeSubmit instead.');
    this.beforeSubmit = new NewsletterFormBeforeSubmit();
  }
  return newsletter_brands_createClass(NewsletterBrands, [{
    key: "init",
    value: function init() {
      console.warn('This method is maintained for backward compatibility. The initialization happens automatically in the constructor.');
    }
  }]);
}()));

/******/ })()
;